<template>
  <div class="education-plan-container">
    <div class="page-header">
      <div class="breadcrumb">
        ຂໍ້ມູນໂຮງຮຽນ / <span>ແຜນພັດທະນາການສຶກສາຂັ້ນບ້ານ</span>
      </div>
      <div class="header-main">
        <div>
          <h1>ແຜນພັດທະນາການສຶກສາຂັ້ນບ້ານ</h1>
          <p>ຈັດການຂໍ້ມູນແຜນພັດທະນາການສຶກສາຂັ້ນບ້ານ ແລະ ບູລິມະສິດຕ່າງໆຂອງໂຮງຮຽນ</p>
        </div>
      </div>
    </div>

    <div v-if="loading" class="loading-state-full">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
      <p>ກຳລັງໂຫຼດຂໍ້ມູນ...</p>
    </div>

    <form v-else @submit.prevent="handleSubmit">

      <!-- School Identity Header -->
      <div class="info-card mb-4">
        <div class="section-label"><i class="fas fa-school"></i> ຂໍ້ມູນລະບຸໂຮງຮຽນ</div>
        <div class="field-row-4">
          <div class="form-group">
            <label class="req">1. ສົກຮຽນ</label>
            <input type="text" v-model="form.academic_year" placeholder="ຕົວຢ່າງ: 2024-2025"
                   pattern="\d{4}-\d{4}" title="ຮູບແບບ: YYYY-YYYY" maxlength="9">
          </div>
          <div class="form-group">
            <label>2. ລະຫັດໂຮງຮຽນ</label>
            <input type="text" :value="schoolInfo.school_id || user.school_id || user.school_code" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>3. ຊື່ແຂວງ</label>
            <input type="text" :value="schoolInfo.prov_name || user.prov_name || user.province_name" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>4. ຊື່ເມືອງ</label>
            <input type="text" :value="schoolInfo.district_name_lao || user.district_name_lao || user.district_name" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
        </div>
        <div class="field-row-3">
          <div class="form-group">
            <label>5. ຊື່ຕາແສງ</label>
            <input type="text" :value="schoolInfo.commune_name || ''" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>6. ຊື່ບ້ານທີ່ໂຮງຮຽນຕັ້ງຢູ່</label>
            <input type="text" :value="schoolInfo.school_village || ''" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>7. ຊື່ໂຮງຮຽນ</label>
            <input type="text" :value="schoolInfo.school_name_lao || user.school_name" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
        </div>
      </div>

      <!-- Plan Form -->
      <div class="card form-wrap">
        <div class="form-group">
          <label class="form-label">ໃນສົກຮຽນນີ້ ໂຮງຮຽນມີ ແຜນພັດທະນາການສຶກສາຂັ້ນບ້ານບໍ່?</label>
          <div class="radio-group">
            <label class="radio-label">
              <input type="radio" v-model="form.has_village_plan" :value="1"> ມີ
            </label>
            <label class="radio-label">
              <input type="radio" v-model="form.has_village_plan" :value="0"> ບໍ່ມີ
            </label>
          </div>
        </div>

        <div class="plans-section">
          <div v-for="(plan, index) in form.plans" :key="index" class="plan-item">
            <div class="plan-item-header">
              <span class="plan-item-title">ແຜນບູລິມະສິດ ທີ {{ index + 1 }}</span>
              <button v-if="form.plans.length > 1" type="button" class="btn-remove" @click="removePlan(index)">
                <i class="fas fa-trash-alt"></i> ລຶບ
              </button>
            </div>

            <div class="form-group">
              <label class="form-label">ລາຍລະອຽດແຜນ</label>
              <textarea v-model="plan.description" class="form-input" rows="3" placeholder="ປ້ອນລາຍລະອຽດແຜນບູລິມະສິດ..."></textarea>
            </div>

            <div class="form-row">
              <div class="form-col">
                <label class="form-label">ຄາດຄະເນວັນທີເລີ່ມຕົ້ນ</label>
                <input type="text" v-model="plan.start_date_text" @input="handlePlanDateInput(plan, 'start_date')" placeholder="dd/mm/yyyy" inputmode="numeric" maxlength="10" class="form-input">
              </div>
              <div class="form-col">
                <label class="form-label">ຄາດຄະເນວັນທີສໍາເລັດ</label>
                <input type="text" v-model="plan.end_date_text" @input="handlePlanDateInput(plan, 'end_date')" placeholder="dd/mm/yyyy" inputmode="numeric" maxlength="10" class="form-input">
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">ຄາດຄະເນງົບປະມານໃນກິດຈະກໍານີ້ (ກີບ)</label>
              <input type="number" v-model="plan.estimated_budget" class="form-input" placeholder="0" min="0">
            </div>

            <div class="form-group">
              <label class="form-label">ເປີເຊັນຄວາມຄືບໜ້າໃນປັດຈຸບັນ: {{ plan.progress_percent }}%</label>
              <input type="range" v-model="plan.progress_percent" min="0" max="100" class="form-range">
            </div>
          </div>

          <button type="button" class="btn-add" @click="addPlan">
            <i class="fas fa-plus"></i> ເພີ່ມລາຍການແຜນ
          </button>
        </div>

        <div class="form-group" style="margin-top: 20px;">
          <label class="form-label">ແຜນພັດທະນາອື່ນໆ</label>
          <textarea v-model="form.other_plans" class="form-input" rows="3" placeholder="ປ້ອນລາຍລະອຽດແຜນພັດທະນາອື່ນໆ..."></textarea>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-save" :disabled="submitting">
            <i class="fas" :class="submitting ? 'fa-spinner fa-spin' : 'fa-save'"></i>
            {{ submitting ? 'ກຳລັງບັນທຶກ...' : 'ບັນທຶກຂໍ້ມູນ' }}
          </button>
        </div>
      </div>

    </form>

    <!-- Result Modal -->
    <transition name="modal">
      <div v-if="resultModal.show" class="modal-overlay" @mousedown.self="resultModal.show = false">
        <div class="custom-modal-card result-modal">
          <div class="modal-icon" :class="resultModal.type">
            <i class="fas" :class="resultModal.type === 'success' ? 'fa-check-circle' : 'fa-times-circle'"></i>
          </div>
          <div class="modal-content-area">
            <h2>{{ resultModal.title }}</h2>
            <p>{{ resultModal.message }}</p>
          </div>
          <div class="modal-footer-actions">
            <button class="btn-modal-primary" :class="resultModal.type" @click="resultModal.show = false">ເຂົ້າໃຈແລ້ວ</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/utils/api';

export default {
  name: 'EducationDevelopmentPlanPage',
  data() {
    return {
      loading: false,
      submitting: false,
      isNew: true,
      user: {},
      schoolInfo: { school_id: '', prov_name: '', district_name_lao: '', school_name_lao: '', commune_name: '', school_village: '' },
      form: {
        school_id: '',
        academic_year: '',
        has_village_plan: 0,
        plans: [{ description: '', start_date: '', end_date: '', start_date_text: '', end_date_text: '', estimated_budget: 0, progress_percent: 0 }],
        other_plans: ''
      },
      resultModal: { show: false, type: 'success', title: '', message: '' }
    };
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem('user-info') || '{}');
    await Promise.all([this.fetchSchoolInfo(), this.fetchData()]);
  },
  methods: {
    async fetchSchoolInfo() {
      if (!this.user.school_id) return;
      try {
        const res = await api.get(`/getAll/schools/school_id/${this.user.school_id}`);
        if (res.data.code === 1 && res.data.rows.length > 0) {
          const s = res.data.rows[0];
          this.schoolInfo = {
            school_id: s.school_id || this.user.school_id,
            prov_name: s.prov_name || '',
            district_name_lao: s.district_name_lao || '',
            school_name_lao: s.school_name_lao || '',
            commune_name: s.commune_name || '',
            school_village: s.school_village || '',
          };
        }
      } catch (e) { console.error(e); }
    },
    async fetchData() {
      if (!this.user.school_id) return;
      this.loading = true;
      try {
        const res = await api.get(`/getAll/school_edu_plan/school_id/${this.user.school_id}`);
        if (res.data.code === 1 && res.data.rows.length > 0) {
          const d = res.data.rows[0];
          if (!Array.isArray(d.plans) || !d.plans.length) {
            d.plans = [{ description: '', start_date: '', end_date: '', start_date_text: '', end_date_text: '', estimated_budget: 0, progress_percent: 0 }];
          } else {
            d.plans = d.plans.map(p => ({
              ...p,
              start_date_text: this.formatPlanDate(p.start_date),
              end_date_text: this.formatPlanDate(p.end_date)
            }));
          }
          this.form = { ...this.form, ...d };
          this.isNew = false;
        } else {
          this.form.school_id = this.user.school_id;
          this.isNew = true;
        }
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    addPlan() {
      this.form.plans.push({ description: '', start_date: '', end_date: '', start_date_text: '', end_date_text: '', estimated_budget: 0, progress_percent: 0 });
    },
    removePlan(index) {
      this.form.plans.splice(index, 1);
    },
    formatPlanDate(iso) {
      if (!iso) return '';
      const [y, m, d] = String(iso).split('-');
      if (!y || !m || !d) return '';
      return `${d}/${m}/${y}`;
    },
    handlePlanDateInput(plan, field) {
      const textField = `${field}_text`;
      const digits = (plan[textField] || '').replace(/\D/g, '').slice(0, 8);
      let formatted = digits;
      if (digits.length > 4) formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4, 8)}`;
      else if (digits.length > 2) formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}`;
      plan[textField] = formatted;

      if (digits.length === 8) {
        const day = digits.slice(0, 2), month = digits.slice(2, 4), year = digits.slice(4, 8);
        plan[field] = `${year}-${month}-${day}`;
      } else {
        plan[field] = '';
      }
    },
    showResult(type, title, message) {
      this.resultModal = { show: true, type, title, message };
    },
    async handleSubmit() {
      this.submitting = true;
      try {
        let res;
        if (this.isNew) {
          res = await api.post('/insertOne', { table: 'school_edu_plan', items: this.form });
        } else {
          res = await api.put(`/update/school_edu_plan/${this.form._id}`, { items: this.form });
        }
        if (res.data.code === 1) {
          this.showResult('success', 'ສຳເລັດແລ້ວ', 'ບັນທຶກຂໍ້ມູນແຜນພັດທະນາການສຶກສາຮຽບຮ້ອຍແລ້ວ');
          await this.fetchData();
        } else {
          this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', res.data.desc || 'ບໍ່ສາມາດບັນທຶກຂໍ້ມູນໄດ້');
        }
      } catch (e) {
        this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', 'ບໍ່ສາມາດເຊື່ອມຕໍ່ກັບເຊີເວີໄດ້');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.education-plan-container {
  max-width: 1000px; margin: 0 auto;
  font-family: 'Phetsarath OT', 'Noto Sans Lao', sans-serif;
  animation: fadeIn 0.4s ease;
}

/* Page Header */
.page-header { margin-bottom: 24px; }
.breadcrumb { font-size: 13px; color: #94a3b8; margin-bottom: 6px; }
.breadcrumb span { color: #334155; font-weight: 600; }
.header-main h1 { font-size: 22px; color: #1e293b; margin: 0 0 4px; }
.header-main p { font-size: 13px; color: #64748b; margin: 0; }

/* Loading */
.loading-state-full {
  display: flex; flex-direction: column; align-items: center;
  justify-content: center; padding: 100px 0; color: #64748b; gap: 16px;
}

/* School Identity Card */
.info-card {
  background: white; border-radius: 16px; padding: 24px 28px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07); border-left: 4px solid var(--lao, #003f8a);
}
.section-label {
  font-size: 13px; font-weight: 700; color: var(--lao, #003f8a);
  margin-bottom: 16px; display: flex; align-items: center; gap: 8px;
}
.field-row-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 16px; }
.field-row-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.form-group { position: relative; }
.form-group label { display: block; font-size: 13px; color: #475569; margin-bottom: 6px; font-weight: 600; }
.form-group input, .form-group select, .form-group textarea {
  width: 100%; padding: 9px 11px; border: 1px solid #e2e8f0; border-radius: 8px;
  font-size: 14px; box-sizing: border-box; font-family: 'Phetsarath OT', inherit;
}
.form-group input:focus, .form-group select:focus, .form-group textarea:focus {
  outline: none; border-color: var(--lao, #003f8a); box-shadow: 0 0 0 3px rgba(0,63,138,0.1);
}
.auto-field { background: #f1f5f9 !important; color: #64748b; }
.auto-badge {
  display: inline-block; font-size: 10px; font-weight: 700;
  background: #e0f2fe; color: #0284c7; border-radius: 4px;
  padding: 1px 6px; margin-top: 4px;
}
.req::after { content: ' *'; color: #ef4444; }
.mb-4 { margin-bottom: 20px; }

/* Plan card */
.card {
  background: #fff; border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1); padding: 24px;
}
.form-label { display: block; margin-bottom: 8px; font-weight: 600; color: #334155; font-size: 14px; }
.form-input {
  width: 100%; padding: 10px 12px; border: 1px solid #e2e8f0;
  border-radius: 8px; font-size: 14px; transition: border-color 0.2s;
  box-sizing: border-box; font-family: 'Phetsarath OT', inherit;
}
.form-input:focus { outline: none; border-color: var(--lao, #003f8a); box-shadow: 0 0 0 3px rgba(0,63,138,0.1); }
.form-row { display: flex; gap: 16px; margin-bottom: 20px; }
.form-col { flex: 1; }
.radio-group { display: flex; gap: 24px; }
.radio-label { display: flex; align-items: center; gap: 8px; cursor: pointer; font-size: 14px; }
.form-range { width: 100%; margin-top: 8px; height: 6px; background: #e2e8f0; border-radius: 5px; appearance: none; }

/* Plans section */
.plans-section { display: flex; flex-direction: column; gap: 16px; margin-bottom: 4px; }
.plan-item { border: 1px solid #e2e8f0; border-radius: 10px; padding: 20px; background: #f8fafc; }
.plan-item-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.plan-item-title { font-weight: 700; font-size: 15px; color: var(--lao, #003f8a); }

/* Buttons */
.btn-remove {
  background: #fee2e2; color: #dc2626; border: none; border-radius: 6px;
  padding: 6px 12px; font-size: 13px; font-weight: 600; cursor: pointer;
  display: inline-flex; align-items: center; gap: 6px; transition: background 0.2s;
}
.btn-remove:hover { background: #fecaca; }

.btn-add {
  background: #eff6ff; color: var(--lao, #003f8a); border: 2px dashed #93c5fd;
  border-radius: 8px; padding: 12px 20px; font-size: 15px; font-weight: 600;
  cursor: pointer; display: inline-flex; align-items: center; gap: 8px;
  transition: background 0.2s, border-color 0.2s; width: 100%;
  justify-content: center; margin-top: 4px; font-family: 'Phetsarath OT', inherit;
}
.btn-add:hover { background: #dbeafe; border-color: #3b82f6; }

.form-actions { border-top: 1px solid #e2e8f0; padding-top: 20px; margin-top: 24px; }
.btn-save {
  width: 100%; background: var(--lao, #003f8a); color: white;
  padding: 14px 50px; border-radius: 10px; font-weight: 700; border: none;
  cursor: pointer; transition: 0.3s; font-size: 15px;
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  font-family: 'Phetsarath OT', inherit;
}
.btn-save:hover:not(:disabled) { background: #002d62; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,63,138,0.3); }
.btn-save:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }

/* Result Modal */
.modal-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4); backdrop-filter: blur(4px);
  display: flex; justify-content: center; align-items: center; z-index: 9999;
}
.custom-modal-card {
  background: white; width: 100%; max-width: 450px;
  border-radius: 16px; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.15);
  overflow: hidden; animation: modalPop 0.3s ease;
}
.result-modal { text-align: center; padding: 40px 30px; }
.modal-icon { font-size: 60px; margin-bottom: 20px; }
.modal-icon.success { color: #10b981; }
.modal-icon.error { color: #ef4444; }
.modal-content-area h2 { margin: 0 0 8px; color: #1e293b; }
.modal-content-area p { color: #64748b; margin: 0; }
.modal-footer-actions { margin-top: 28px; }
.btn-modal-primary {
  padding: 12px 40px; border: none; border-radius: 10px;
  font-weight: 700; cursor: pointer; font-size: 15px;
  background: var(--lao, #003f8a); color: white;
  font-family: 'Phetsarath OT', inherit;
}
.btn-modal-primary.error { background: #ef4444; }

@keyframes modalPop { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

@media (max-width: 900px) {
  .field-row-4 { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 600px) {
  .field-row-3, .field-row-4 { grid-template-columns: 1fr; }
  .form-row { flex-direction: column; }
}
</style>
